import React from "react";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		wrapper: {
			width: "100%",
			overflow: "hidden",
		},
		table: {
			display: "flex",
			flexWrap: "wrap",
			position: "relative",
			left: 0,
			transition: "transform .3s linear",
			transform: "translate3d(0,0,0)",
		},
	};
};

class CompareTable extends React.Component {
	static defaultProps = {
		data: [],
	};

	render() {
		let columns = this.props.data.length < 7 ? this.props.data.length : 6;
		let classes = this.props.classes;
		let children = React.Children.map(this.props.children, (item) => {
			return React.cloneElement(item, {
				columns: columns,
				moveValue: this.props.moveValue,
				data: this.props.data,
			});
		});
		return (
			<div className={classes.wrapper}>
				<div
					className={classes.table}
					style={{
						transform: `translateX(${-1 * this.props.moveValue}px)`,
					}}
				>
					{children}
				</div>
			</div>
		);
	}
}
export default withStyles(styles)(CompareTable);
